import { useState, type ElementType } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { LayoutDashboard, TrendingUp, Truck, Receipt, Users, BarChart2 } from 'lucide-react';
import DashboardTab from './DashboardTab';
import RevenueTab from './RevenueTab';
import PurchasesTab from './PurchasesTab';
import ExpensesTab from './ExpensesTab';
import ShareholdersTab from './ShareholdersTab';
import InventorySalesTab from './InventorySalesTab';

type Tab = 'dashboard' | 'revenue' | 'inventory_sales' | 'purchases' | 'expenses' | 'shareholders';

const TABS: { key: Tab; label: string; icon: ElementType }[] = [
  { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { key: 'revenue', label: 'Revenue', icon: TrendingUp },
  { key: 'inventory_sales', label: 'Inventory Sales', icon: BarChart2 },
  { key: 'purchases', label: 'Purchases', icon: Truck },
  { key: 'expenses', label: 'Expenses', icon: Receipt },
  { key: 'shareholders', label: 'Shareholders', icon: Users },
];

export default function AccountsPage() {
  const { isDark } = useTheme();
  const [tab, setTab] = useState<Tab>('dashboard');
  const [dashboardKey, setDashboardKey] = useState(0);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Accounts</h1>
        <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>Purchases, expenses and (soon) profit &amp; loss</p>
      </div>

      {/* Tab switcher — matches the Inventory page tab style */}
      <div className="flex items-center gap-1">
        {TABS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            onClick={() => { setTab(key); if (key === 'dashboard') setDashboardKey(k => k + 1); }}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              tab === key
                ? 'bg-emerald-500 text-white'
                : isDark ? 'text-gray-400 hover:text-white hover:bg-gray-800' : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
            }`}
          >
            <Icon size={16} /> {label}
          </button>
        ))}
      </div>

      {tab === 'dashboard' && <DashboardTab key={dashboardKey} isDark={isDark} />}
      {tab === 'revenue' && <RevenueTab isDark={isDark} />}
      {tab === 'inventory_sales' && <InventorySalesTab isDark={isDark} />}
      {tab === 'purchases' && <PurchasesTab isDark={isDark} />}
      {tab === 'expenses' && <ExpensesTab isDark={isDark} />}
      {tab === 'shareholders' && <ShareholdersTab isDark={isDark} />}
    </div>
  );
}
